import CountUp from 'react-countup';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import ProgressLine from 'Components/ProgressLine';
import { Typography } from 'Components/Typography';

import { productsCategories } from 'constants/products';

import { type ConsultationCategoryProp } from 'PropTypes/consultationProps';

import { QuestionLayout } from './QuestionLayout';

const GeoResultContainer = styled.div`
  display: flex;
  flex: 1 0 auto;
  flex-flow: row wrap;
  justify-content: center;
  align-items: flex-start;
  padding: 15px 0;

  ${legacyTheme.breakpoints.up('md')} {
    place-content: flex-start center;
  }
`;

const GeoResult = styled.div`
  width: 100%;
  padding: 20px;

  text-align: center;

  ${legacyTheme.breakpoints.up('md')} {
    width: 50%;
  }

  & > *:last-child {
    margin: 17px 0;
  }
`;

const Label = styled(Typography)`
  margin: 9px 0;

  font-size: 14px;
  color: ${theme.colors.neutral[800]};
`;

type GeoAggressorsProps = {
  aggressors: {
    city: string;
    humidity: number;
    pollen?: number;
    pollution: number;
    state: string;
    uv: number;
    water: number;
    wind: number;
  };
  consultationCategory: ConsultationCategoryProp;
  onNext: () => void;
  subtitle: string;
  title: string;
};

export const GeoAggressors = ({
  aggressors: { city, state, uv, pollution, humidity, water, wind },
  consultationCategory,
  onNext,
  subtitle,
  title,
  ...props
}: GeoAggressorsProps) => {
  const resultList = [
    { label: 'UV Rays', value: uv },
    { label: 'Pollution', value: pollution },
    { label: 'Water Hardness', value: water },
    { label: 'Humidity', value: humidity },
    { label: 'Wind', value: wind },
  ];
  const categoryMap = {
    [productsCategories.HAIRCARE]: 'hair',
    [productsCategories.SKINCARE]: 'skin',
    [productsCategories.AGNOSTIC]: '',
  };
  const categoryNameForSubtitle = categoryMap[consultationCategory];

  return (
    <QuestionLayout
      consultationCategory={consultationCategory}
      submit={onNext}
      subtitle={subtitle.replace('__category__', categoryNameForSubtitle)}
      title={title.replace('__city__', city).replace('__state__', state)}
      {...props}
    >
      <GeoResultContainer>
        {resultList.map(({ label, value }) => (
          <GeoResult key={label}>
            <Label bold variant="mono2">
              {label} <CountUp duration={1} end={value} start={0} />
              /100
            </Label>
            <ProgressLine
              // @ts-expect-error - ProgressLine has no TS types yet
              animationDuration="1.25s"
              backgroundColor={theme.colors.primary[100]}
              color={theme.colors.primary[300]}
              height="8px"
              progress={value}
            />
          </GeoResult>
        ))}
      </GeoResultContainer>
    </QuestionLayout>
  );
};
